import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

export const BLINK_DURATION = 4500

const blinkColor = 'rgba(22, 159, 218, 0.075)'

const sharedTableHeadData = {
  margin: '0'
}

type StylesType = {
  variant: string
  loaded: boolean
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  root: {
    position: 'relative',
    display: 'block',
    boxShadow: '0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.08)',
    borderRadius: '0.5rem',
    backgroundColor: 'white',
    maxWidth: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',

    '& .wrapper': {
      display: 'block',
      maxWidth: '100%',
      minHeight: ({ loaded }) => (loaded ? 'unset' : '200px'),
      overflowX: 'scroll',
      overflowY: 'hidden',

      '@media (max-width: 575px)': {
        overflowX: ({ variant }) =>
          variant === 'notification' ? 'hidden' : 'unset'
      }
    },

    '& .table': {
      borderCollapse: 'collapse',
      width: '100%',

      '& .thead': {
        zIndex: 10,
        position: 'relative',
        boxShadow: `0 1px 0 0 ${theme.palette.primary.main}`,
        backgroundColor: '#f8d8ff',

        '& > tr': {
          boxShadow: 'none !important'
        }
      },

      '& .sort': {
        marginLeft: '0.5rem'
      },

      '& .tbody': {
        height: '100%',

        '& .no-data': {
          display: 'flex',
          justifyContent: 'center',
          color: '#7f8487',
          opacity: '0.7'
        },

        '& .table-row:hover': {
          backgroundColor: '#f7f8f9',

          '& .fade': {
            color: '#7f848799'
          }
        }
      },

      '& .table-row.clickable': {
        cursor: 'pointer'
      },

      '& .table-row': {
        boxShadow: '0 1px 0 0 rgba(230, 234, 236, 0.9)'
      },

      '& .blink': {
        animation: `$blink ${BLINK_DURATION}ms`
      },

      '& .skeleton': {
        marginBottom: '1px',
        width: '100%',
        height: '36px',
        animation: `$skeleton 1s linear infinite alternate`
      },

      '& .skeleton-static': {
        marginBottom: '1px',
        width: '100%',
        height: '36px',
        backgroundColor: 'hsl(0, 0%, 90%)'
      },

      '& .updated-row > .table-data': {
        animation: `$blinkText 150ms 3`
      },

      '& .table-t': {
        position: 'relative',
        backgroundColor: 'transparent !important',

        '&:hover .resizer': {
          display: 'block'
        }
      },

      '& .table-head': {
        backgroundColor: 'transparent !important',
        fontSize: theme.size.sm,
        userSelect: 'none',
        color: '#b64fcd',
        textTransform: 'uppercase',

        ...sharedTableHeadData
      },

      '& .resizer': {
        display: 'none',
        zIndex: 1000,
        position: 'absolute',
        right: '0',
        top: '0',
        height: '100%',
        width: '6px',
        background: 'rgba(0, 0, 0, 0.3)',
        cursor: 'col-resize',
        userSelect: 'none',
        touchAction: 'none'
      },

      '& .table-data': {
        ...sharedTableHeadData,

        padding: '0 0.5rem',
        fontSize: theme.size.sm,
        color: '#323436',
        overflow: 'hidden'
      },

      '& .table-data:not(:last-child)': {
        borderRight: '0.0625rem solid rgba(230, 234, 236, 0.5)'
      },

      '& .table-data:nth-child(2)': {
        '@media (max-width: 575px)': {
          padding: ({ variant }) =>
            variant === 'notification' ? '0.5rem' : '0'
        }
      },

      '& .table-head.table-t': {
        padding: '0.5rem'
      },

      '& .table-row > .table-head:first-child': {
        paddingLeft: '1rem'
      },

      '& .table-row > .table-head:not(:last-child)': {
        boxShadow: '1px 0 0px 0 rgba(230, 234, 236, 0.5)'
      },

      '& .sticky-thead': {
        position: 'sticky',
        top: '0'
      },

      '& .sticky-tbody': {
        overflowY: 'auto'
      }
    },

    '& .arrow': {
      marginRight: '0.25rem',
      transition: 'transform 500ms',
      fontSize: theme.size.base,
      color: theme.palette.primary.main,
      cursor: 'pointer',
      minWidth: '1rem',
      height: '1rem',
      width: '1rem'
    },

    '& .center-arrow': {
      alignSelf: 'center'
    },

    '& .arrow-down': {
      transform: 'rotate(90deg)'
    },

    '& .section': {
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.size.sm,
      userSelect: 'none',

      '& .title': {
        opacity: '0.5',
        color: '#323436',
        textTransform: 'uppercase'
      },

      '& .count': {
        marginLeft: '0.25rem',
        color: theme.palette.primary.main
      }
    }
  },

  '@keyframes blink': {
    '0%': {
      backgroundColor: blinkColor
    },

    '56%': {
      backgroundColor: blinkColor
    },

    '100%': {
      backgroundColor: 'white'
    }
  },

  '@keyframes skeleton': {
    '0%': {
      backgroundColor: 'hsl(0, 0%, 90%)'
    },

    '100%': {
      backgroundColor: 'hsl(0, 0%, 93%)'
    }
  },

  '@keyframes blinkText': {
    '0%': {
      opacity: '1'
    },

    '50%': {
      opacity: '0'
    },

    '100%': {
      opacity: '1'
    }
  }
}))

export default useStyles
